import { styled } from '@mui/material';

export type ColorEnum =
  | 'primary'
  | 'secondary'
  | 'success'
  | 'error'
  | 'warning'
  | 'info'
  | 'heaven';

export type StateEnum = 'checked' | 'unchecked' | 'indeterminate';

interface IconProps {
  color?: ColorEnum;
  state?: StateEnum;
}

export const commonIconStyle = {
  borderRadius: '4px',
  width: '14px',
  height: '14px'
};

export const Icon = styled('span', {
  shouldForwardProp: (prop) => prop === 'theme' || prop === 'children',
  slot: 'Root'
})<IconProps>(({ theme, color, state }) => {
  let checkboxColor = theme.palette.grey['500'];
  if (
    color &&
    color in theme.palette &&
    'light' in theme.palette[color as ColorEnum] &&
    'main' in theme.palette[color as ColorEnum]
  ) {
    if (state && state === 'checked') {
      checkboxColor = theme.palette[color as ColorEnum].main;
    } else {
      checkboxColor = theme.palette[color as ColorEnum].light;
    }
  } else {
    if (state && state === 'checked') {
      checkboxColor = theme.palette.primary.main;
    }
  }
  return {
    ...commonIconStyle,
    color: checkboxColor,
    border: `1.5px solid ${checkboxColor}`
  };
});
